export const headerNav = () => {
  window.headerNav = function ($el) {
    return {
      selected: '',
      active: false,
      timeout: null,
      activePreview: null,
      activeSubnav: null,
      navHeight: null,
      subnavHeight: null,
      open () {
        this.active = true;
        this.activePreview = null;
        this.activeSubnav = null;
      },
      close () {
        this.active = false;
        this.activePreview = null;
        this.activeSubnav = null;
        this.$refs.subnav.style.display = 'none';
      },
      setActiveNav (event, hasChildren) {
        if (!hasChildren) {
          this.active = false;
          for (const element of this.$refs.sections.getElementsByClassName('item')) {
              element.classList.remove('current');
              // This won’t work if Contact is no longer the last item.
              element.classList.add('left');
          }
          return;
        } else {
          this.open();
        }

        let root = document.documentElement;
        this.$refs.subnav.style.display = 'flex';
        const offset = event.target.getBoundingClientRect().x - this.$refs.subnav.getBoundingClientRect().x;
        const targetSubnav = event.target.getAttribute('data-target');

        root.style.setProperty('--nav-target-x', `${offset}px`);

        // loop over all items and set left or right classes
        let foundActive = false;
        let current = null;
        for (const element of this.$refs.sections.getElementsByClassName('item')) {
          if (targetSubnav === element.getAttribute('id')) {
            foundActive = true;
            element.classList.remove('left', 'right');
            element.classList.add('current');
            current = element;
          } else if (foundActive === false) {
            element.classList.remove('current', 'right');
            element.classList.add('left');
          } else if (foundActive) {
            element.classList.remove('current', 'left');
            element.classList.add('right');
          }
        }

        this.navHeight = current.getBoundingClientRect().height;

        //root.style.setProperty('--nav-target-width', `${current.getBoundingClientRect().width}px`);
        //root.style.setProperty('--nav-target-height', `${current.getBoundingClientRect().height}px`);

        this.activeSubnav = null;
      },
      preview (event) {
        this.activePreview = event.target.getAttribute('data-preview-target');

        if (!document.getElementById(this.activePreview)) {
          this.activePreview = event.target.getAttribute('data-preview-parent');
        }
      },
      leavePreview (event) {
        let root = document.documentElement;
        //root.style.setProperty('--nav-target-height', `${this.navHeight}px`);

        this.activePreview = null;
      },
      changeSubnav (event, value) {
        let root = document.documentElement;

        this.activeSubnav = value;
        this.activePreview = null;

        this.$nextTick(() => {
          this.subnavHeight = document.querySelector('.child-nav.active').scrollHeight;
          //root.style.setProperty('--nav-target-height', `${this.subnavHeight + 94}px`);
          //root.style.setProperty('--subnav-target-height', `${this.subnavHeight}px`);
        });
      }
    }
  };
}
